<template>
  <v-menu
    v-model="startEndTimeOpen"
    :max-width="378"
    :min-width="378"
    :close-on-content-click="false"
    content-class="UXDatapicker hoursPicker"
    :disabled="dis"
  >
    <template v-slot:activator="{ on }">
      <div class="UXdatetimeInput outline" :class="{ disabled: dis }" v-on="on">
        <span class="inpTxt" v-if="picker !== ''">{{ picker }}</span>
        <span class="inpTxt" v-else>시작시간 - 종료시간</span>
        <i class="UXicon-down"></i>
      </div>
    </template>

    <v-card class="UXdtpCard">
      <div class="head">
        <p>
          <strong>
            <span v-if="startHour || endHour"> {{ startHour }} : 00 ~ {{ endHour }} : 00 </span>
            <span v-else>시간선택</span>
          </strong>
        </p>
        <div class="endBtn" v-if="startHour && endHour">
          <v-btn dark color="#5578F0" @click="setTime">완료</v-btn>
        </div>
      </div>

      <div class="con3">
        <div class="timeBox">
          <div class="startEndHeader">시작시간</div>
          <dl>
            <dd>
              <perfect-scrollbar ref="startHourList">
                <ul>
                  <li v-for="(item, index) in hours" :key="index">
                    <a :class="{ on: startHour == item }" @click="startHour = item">{{ item }}시</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
        </div>

        <div class="timeBox">
          <div class="startEndHeader">종료시간</div>
          <dl>
            <dd>
              <perfect-scrollbar ref="endHourList">
                <ul>
                  <li v-for="(item, index) in endHours" :key="index">
                    <a :class="{ on: endHour == item }" @click="endHour = item">{{ item }}시</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'StartEndTimePicker',
  data() {
    return {
      startEndTimeOpen: false,
      hours: [],
      endHours: [],
      startHour: '',
      endHour: '',
      endMinute: '',
      picker: ''
    };
  },
  props: ['startTime', 'endTime', 'dis'],
  created() {
    for (let i = 0; i < 24; i++) {
      if (this.hours.length <= 23 && i >= 0) {
        this.hours.push(i.toString().length > 1 ? i : '0' + i.toString());
        this.endHours.push((i + 1).toString().length > 1 ? i + 1 : '0' + (i + 1).toString());
      }
    }
    setTimeout(() => {
      this.resetTime();
    }, 50);
  },
  watch: {
    startTime() {
      this.resetTime();
    },
    endTime() {
      this.resetTime();
    },
    startEndTimeOpen(val) {
      if (val) {
        setTimeout(() => this.moveScroll(), 300);
      }
    }
  },
  methods: {
    resetTime() {
      if (this.startTime || this.endTime) {
        this.startHour = typeof this.startTime === 'number' && this.startTime < 10 ? `0${this.startTime.toString()}` : this.startTime;
        this.endHour = typeof this.endTime === 'number' && this.endTime < 10 ? `0${this.endTime.toString()}` : this.endTime;

        this.picker = `${this.startHour}:00 ~ ${this.endHour}:00`;
      }
    },
    moveScroll() {
      const itemSize = 22;

      if (this.startTime) {
        this.$refs.startHourList.$el.scrollTop = this.$refs.startHourList ? Number(this.startHour) * itemSize : 0;
      }
      if (this.endTime) {
        this.$refs.endHourList.$el.scrollTop = this.$refs.endHourList ? (Number(this.endHour) - 1) * itemSize : 0;
      }
    },
    setTime() {
      if (this.startHour > this.endHour) {
        this.$alertMsg('시작시간이 종료시간보다 늦을 수 없습니다.');
        return false;
      }
      let time = {
        start: Number(this.startHour),
        end: Number(this.endHour)
      };
      this.$emit('child', time);
      this.picker = `${time.start}:00 ~ ${time.end}:00`;
      this.startEndTimeOpen = false;
    }
  }
};
</script>

<style lang="scss">
.hoursPicker {
  .con3 {
    .timeBox {
      dl {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HoursTimePicker.vue